import styled from "styled-components";
import { rgba } from "../../services/Functions";

export const MeusProdutosView = styled.div`
  width: 100%;
  padding: 5rem 10rem 13rem 10rem;
  overflow: hidden;

  .grid-header {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;

    .select{
      flex-grow: 1;
    }

    .input{
      flex-grow: 1;
    }

    .pesquisa {
      width: 62rem;
    }

    .categorias{
      width: 35rem;
      .view-select {
        .select{
          .selecionado{
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }

    .ativos{
      width: 23rem;
    }

    .estoques{
      width: 40rem;
    }
    
    .tags {
      width: 23rem;
    }

    .filtro {
      display: flex;
      align-items: center;

      .containerSelects {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding: 2rem 0;
      }
    }

    .botoes{
      display: flex;
      gap: 2rem;
      flex-wrap: wrap;
    }
  }

  .produtos {
    width: 100%;
    padding: 10rem 0;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
    gap: 4rem;
    align-items: center;
    justify-content: space-between;
    justify-items: center;

    .options-mobile {
      transform: translateY(25%) translateX(20rem) scale(0);
      display: flex;
      justify-content: center;
      flex-direction: column;
      background-color: ${(props) => props.theme.colors.white};
      align-items: center;
      position: fixed;
      z-index: 50;
      bottom: 23rem;
      right: 13rem;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 2px 0px;
      border-radius: 16px;
      transition: all 0.2s ease-in-out;

      &.ativo {
        transform: translateY(0%) translateX(0%) scale(1);
      }
      .option {
        text-align: left;
        width: 100%;
        color: ${(props) => props.theme.colors.placeholder};
        padding: 1rem 2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;

        svg {
          width: 2rem;
          height: 2rem;
        }

        &.ativo {
          color: ${(props) => props.theme.colors.tertiary};
          background-color: ${(props) =>
            rgba(props.theme.colors.secondary, 0.3)};
        }
        &.primeiro {
          border-top-right-radius: 16px;
          border-top-left-radius: 16px;
        }
        &.ultimo {
          border-bottom-right-radius: 16px;
          border-bottom-left-radius: 16px;
        }

        > .blocked{
          color: ${(props) => props.theme.colors.disable};
          &::after{
          position: fixed;
        }
    }
      }
    }

    .mensagem {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      grid-column: 2 / -1;

      .texto-titulo {
        color: ${(props) => props.theme.colors.tertiary};
      }

      .texto-subtitulo {
        color: ${(props) => props.theme.colors.tertiary};
      }
      
      @media (max-width: 1024px) {
        grid-column: 1 / -1;
      }
    }

    .produto-container {
      width: 100%;
      height: 100%;

      a {
        width: 100%;
        height: 100%;
      }
    }

    .center {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: 100%;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 2px 0px;
      transition: all 0.3s ease-in-out;
      border-radius: 16px;
      &.inativo {
        .cadastro {
          opacity: 0.3;
        }
      }
    }

    .adicionar_produto {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      justify-content: center;
      position: relative;
      border-radius: 16px;
      min-height: 15rem;
      width: 100%;
      aspect-ratio: 1/1;
      border-bottom: 2px solid #c7c7c7;
      position: relative;
      background-color: ${(props) => props.theme.colors.primary};
      transition: transform 0.12s ease-out, border-bottom-color 0.12s ease-out,
        filter 0.12s ease-out;

      &:active {
        transform: translateY(3px);
        border-bottom-color: #000000;
        filter: brightness(0.92);
      }

      .plus {
        fill: ${(props) => props.theme.colors.white};
      }

      .locked{
        svg{
          fill: ${(props) => props.theme.colors.white};
          path{
            fill: ${(props) => props.theme.colors.white};
          }
        }

        &::after{
          position: fixed;
          left: 45rem;
          bottom: 110rem;
        }
      }
    }
    .cadastro {
      padding: 2rem 4rem;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      background-color: ${(props) => props.theme.colors.white};
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      .texto {
        text-align: left;
        color: ${(props) => props.theme.colors.placeholder};
      }
      
      .select {
        text-align: left;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 3rem 3rem 13rem 3rem;

    .produtos {
      grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
    }
  }
`;

export const ModalNovoProduto = styled.div`
  padding-top: 15px;
  padding-bottom: 30px;
  .titulo {
    line-height: 1;
    margin: 20px 0;

    span {
      color: ${(props) => props.theme.colors.secondary};
      font-weight: bold;
    }
  }

  .link {
    display: flex;
    justify-content: center;
    align-items: center;

    .center {
      display: flex;
      justify-content: center;
      gap: 1rem;
      align-items: flex-end;
      width: 80%;
      background-color: ${(props) => props.theme.colors.primary};
      border-radius: 30px;
      margin: 7px 0;
      padding: 7px 0;
      cursor: pointer;
      text-decoration: none;
      color: ${(props) => props.theme.colors.white};
      svg{
        flex-shrink: 0;
        path{
          fill: ${(props) => props.theme.colors.disable};
        }
      }
    }

    .locked{
      background-color: ${(props) => props.theme.colors.mockup};
      color: ${(props) => props.theme.colors.disable}
    }
  }
`;
